import WeatherMatrixService from "../../services/weathermatrix.service";

const state = {
    weatherChartList: [],
    weatherRegions : [],
    weatherChartTypes : [],
    WeatherChartForm : null,
   // WeatherRegionForm : null,
    isActiveWeatherChartModal : false,
    isActiveWeatherRegionModal : false,

};
const mutations = {

    set_weather_chart(state, payload) {
        state.weatherChartList = payload;
    },

    set_clear_WeatherChart(state) {
        state.WeatherChartForm = [];
    },
/*
    set_clear_WeatherRegion(state) {
        state.WeatherRegionForm = [];
    },
*/
    set_weatherChartTypes(state, payload){
        state.weatherChartTypes = payload;
    },

    set_clear_weatherChartList(state)
    {
        state.weatherChartList = [];
    },

    set_clear_WeatherRegion_list(state)
    {
        state.weatherRegions = [];
    },

    set_clear_weatherChartTypes(state)
    {
        state.weatherChartTypes = [];
    },

    set_weatherRegions(state,payload){
        state.weatherRegions = payload;
    },

    set_close_open_WeatherChartmodal(state) {
        state.isActiveWeatherChartModal = !state.isActiveWeatherChartModal
    },

    set_close_open_WeatherRegionmodal(state) {
        state.isActiveWeatherRegionModal = !state.isActiveWeatherRegionModal
    },
};
const actions = {

    async getWeatherChart({commit}) {
        await commit("set_clear_weatherChartList");
        const weatherChart = await WeatherMatrixService.GetWeatherChart();
        await commit("set_weather_chart", weatherChart);
        return weatherChart;
    },

    async patchWeatherChart({id, chartUri, chartUrl}) {

        const weather = await WeatherMatrixService.SetWeatherPatch(id, chartUri, chartUrl);
        return weather;
    },

    async GetAllWeatherRegions({commit}) {
        await commit("set_clear_WeatherRegion_list");
        const WeatherRegions = await WeatherMatrixService.getWeatherRegions(-1);
        await commit("set_weatherRegions",WeatherRegions);
        return WeatherRegions;
    },

    async GetAllWeatherChartTypes({commit}) {
        await commit("set_clear_weatherChartTypes");
        const WeatherChartTypes = await WeatherMatrixService.getWeatherChartTypes(-1);
        await commit("set_weatherChartTypes",WeatherChartTypes);
        return WeatherChartTypes;
    },

    async openCloseWeatherChartModal({commit}) {
        await commit("set_close_open_WeatherChartmodal");
        await commit("set_clear_WeatherChart");
    },



    async openCloseWeatherRegionModal({commit}) {
        await commit("set_close_open_WeatherRegionmodal");
        //await commit("set_clear_WeatherRegion");
    }


};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}
